module.exports = __webpack_public_path__ + "static/media/footer-section.99add83e.png";